import React from 'react'
import { object, func } from 'prop-types'
import TranslationContext from '../../../utils/TranslationContext'
import styles from './SubscriptionSummary.styl'
import { injectStripe } from 'react-stripe-elements'
import Success from '../../components/Messages/Success'
import { postRequest, getRequest } from '../../../utils/requestActions'

class SubscriptionSummary extends React.Component {

	static propTypes = {
		plan: object,
		paymentInformation: object,
		handleSuccess: func
	}

	static contextType = TranslationContext

	state = {
		processing: false,
		voucherId: '',
		voucherType: '',
		discountPrice: null,
		voucherSucess: false,
		voucherError: false,
		sucess: false
	}

	handlePopup(path) {
		const options = {
			path,
			windowName: 'paypalApproval',
			windowOptions: 'location=0,status=0,width=1200,height=800'
		}
		const paypalWindow = window.open('', options.windowName, options.windowOptions)
		return paypalWindow
	}

	async handleVoucherApply(e) {
		e.preventDefault()
		const { voucherId } = this.state
		const voucherData = await getRequest(`/api/voucher/get/${ voucherId }`)
		if (!voucherData) {
			this.setState({ voucherError: true, voucherSucess: false })
			return
		}
		const { type: voucherType, value: voucherValue } = voucherData
		this.setState({ voucherType, voucherValue, voucherSucess: true, voucherError: false })
	}

	async handleSubmit(e) {
		const { stripe, plan, athlete, paymentInformation, handleSuccess } = this.props
		const { voucherId } = this.state
		const { cardOwner, paymentMethod, paymentType } = paymentInformation
		const { id: planId } = (plan || {})
		// if (paymentMethod === 'paypal') {
		// 	if (paymentType === 'full') {
		// 		const paypalWindow = this.handlePopup()
		// 		const paypalPaymentData = await postRequest('/api/paypal/create_payment',
		// 			{
		// 				planId,
		// 				amount: price * minWeekNumber
		// 			})
		// 		paypalWindow.location = paypalPaymentData.approvalLink.href
		// 	}
		// 	return
		// }
		if (paymentMethod === 'multibanco') {
			const { entity, reference, amount } = await postRequest('/api/stripe/multibanco',
				{
					paymentType,
					planId,
					voucherId
				}
			)
			this.setState({
				multibanco: {
					entity,
					reference,
					amount
				},
				sucess: true,
				processing: false,
				error: { error: false }
			})
			handleSuccess()
			return
		}
		if (paymentMethod === 'card') {
			const { source, error } = await stripe.createSource({
				type: 'card',
				currency: 'eur',
				owner: {
					name: cardOwner,
					email: (athlete || {}).email
				}
			})
			if (error) {
				this.setState(({ error: { error: true, message: 'Alguma coisa correu mal com pagamentos de multibanco!' } }))
				return
			}
			if (source.card.three_d_secure === 'required') {
				return
			}
			await postRequest('/api/stripe/charge',
				{
					sourceId: source.id,
					paymentType,
					planId,
					voucherId
				})
			this.setState({
				sucess: true,
				processing: false,
				error: { error: false }
			})
			handleSuccess()
		}
	}

	render() {
		const { plan, paymentInformation } = this.props
		const { i18n } = this.context
		const { processing, voucherType, voucherId, voucherValue, voucherSucess, voucherError, sucess } = this.state
		const { title, price } = (plan || {})
		const { paymentType, name, bilingAddress, taxpayerNumber, paymentMethod } = paymentInformation
		const { street, city, country, postalCode } = (bilingAddress || {})
		const paymentMethondDictionary = {
			card: i18n`card_label`,
			multibanco: 'Multibanco',
			paypal: 'Paypal'
		}
		const weekNumber = paymentType === 'semester' ? 6 * 4 : 4
		const weekPrice = voucherType === 'percent' ? price * (1 - voucherValue) : price
		const amount = weekPrice * weekNumber
		return (
			<div>
				<div className={ styles['content'] }>
					<h1>{ title }</h1>
					<div className={ styles['details-container'] }>
						<h2>{ i18n`billing_information_label` }</h2>
						<p><strong>{ i18n`name_label` }: </strong>{ name }</p>
						<p><strong>{ i18n`registry_nif_label` }: </strong>{ taxpayerNumber }</p>
						<p><strong>{ i18n`registry_address_label` }: </strong>{ street }</p>
						<p><strong>{ i18n`registry_city_label` }: </strong>{ city }</p>
						<p><strong>{ i18n`registry_country_label` }: </strong>{ country }</p>
						<p><strong>{ i18n`registry_postal_code_label` }: </strong>{ postalCode }</p>
						<h2>{ i18n`payment_information_label` }</h2>
						<p><strong>{ i18n`payment_method_label` }: </strong>{ paymentMethondDictionary[paymentMethod] }</p>
						<p><strong>{ i18n`payment_type_label` }: </strong>{ paymentType === 'semester' ? i18n`full_payment_label` : i18n`monthly_payment_label` }</p>
						<p><strong>{ i18n`price_per_week_label` }: </strong>{ weekPrice }€</p>
						<p><strong>{ i18n`week_label` }: </strong>{ weekNumber }</p>
					</div>
					<hr />
					<h2 className={ styles['total-title'] }>Total: <span>{ amount }€</span></h2>
					<form
						onSubmit={ this.handleVoucherApply.bind(this) }
						className={ styles['voucher-form'] }
					>
						{ voucherSucess ? <span>Voucher applicado com sucesso!</span> : null }
						{ voucherError ? <span>Voucher inválido ou já usado!</span> : null }
						<div>
							<input type="text" placeholder="Voucher" value={ voucherId } onChange={ (e) => { this.setState({ voucherId: e.target.value }) } } />
							<input type="submit" value={ i18n`apply_label` } />
						</div>
					</form>
					<button
						onClick={ () => {
							if (processing) {
								return
							}
							this.setState({ processing: true },
								this.handleSubmit
							)
						} }
						className={ styles['payment-button'] }

					>{ processing ? i18n`processing_label` : i18n`finish_label` }</button>
				</div>
			</div>
		)
	}
}

export default injectStripe(SubscriptionSummary)



// WEBPACK FOOTER //
// ./src/client/webapp/components/SubscriptionSummary/SubscriptionSummary.js